import Vue from 'vue'
import * as VueGoogleMaps from '~/node_modules/vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyA7vQxerhkw9yfmcwg1lhIl_C2JjiIOPuE',
        libraries: 'places',
    },
    installComponents: true
})